"use client";

import { TableSkeletonBody } from "@/components/ui/table";

export function JobsSkeleton({ count }: { count: number }) {
  return (
    <TableSkeletonBody
      count={count}
      renderCells={() => [
        <div key="name" className="flex min-w-0 w-full flex-col gap-1">
          <div className="h-4 w-[90%] max-w-56 rounded bg-contrast/6" />
          <div className="h-3 w-[75%] max-w-40 rounded bg-contrast/6" />
        </div>,
        <div key="employer" className="flex min-w-0 items-center gap-1">
          <div className="size-3 shrink-0 rounded-[2px] bg-contrast/6" />
          <div className="h-5 w-[110px] rounded-sm bg-contrast/6" />
        </div>,
        <div key="ats" className="h-5 bg-contrast/6 rounded w-[100px]" />,
        <div key="date" className="h-4 bg-contrast/6 rounded w-[85px]" />,
        <div
          key="manager"
          className="h-5 bg-contrast/6 rounded-md w-[110px]"
        />,
        <div key="status" className="flex items-center justify-between gap-4">
          <div className="h-5 bg-contrast/6 rounded w-[42px]" />
          <div className="h-4 bg-contrast/6 rounded w-4" />
        </div>,
      ]}
    />
  );
}
